import styled from 'styled-components'

const MyBorrowStyled = styled.div`
  .top-lending {
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
    .search-horse-input {
      height: 34px;
    }
    .lending-search {
      display: flex;
      gap: 20px;
    }
    .lending-sort {
      width: 200px;
    }
  }
`

export default MyBorrowStyled
